export default {
  'audit.review.subTitle': 'Pending audit records in the audit system, including property fees, water fees, electricity fees, network fees, parking fees and other types of fee audits',
  'audit.review.headerTitle': 'Pending Review List',
  'audit.review.column.auditNo': 'Audit No.',
  'audit.review.column.billPeriod': 'Bill Period',
  'audit.review.column.auditName': 'Audit Name',
  'audit.review.column.feeType': 'Fee Type',
  'audit.review.column.totalCount': 'Total Details',
  'audit.review.column.totalAmount': 'Application Amount',
  'audit.review.column.status': 'Audit Status',
  'audit.review.column.submitterName': 'Submitter',
  'audit.review.column.submitTime': 'Submit Time',
  'audit.review.column.action': 'Action',
  'audit.review.action.audit': 'Audit',
  'audit.review.action.auditTooltip': 'Enter Audit',
  'audit.review.error.loadFeeTypes': 'Failed to load fee type dictionary',
  'audit.review.error.loadApproveStatus': 'Failed to load approval status dictionary',
  'audit.review.error.getList': 'Failed to get audit list',
  'audit.review.confirm.delete': 'Are you sure you want to delete this audit record?',
  'audit.review.confirm.batchDelete': 'Are you sure you want to delete the selected audit records?',
  'audit.review.status.unknown': 'Unknown',
  'audit.review.feeType.mixed': 'Mixed Type',
  'audit.review.drawer.title': 'Audit Detail',
  'audit.review.drawer.title.processing': 'Audit Processing',
  'audit.review.drawer.title.detail': 'Audit Detail',
  'audit.review.drawer.tag.dailyExpense': 'Daily Expense',
  'audit.review.drawer.tag.budgetRequest': 'Budget Request',
  'audit.review.drawer.tag.mortgageRepayment': 'Mortgage Repayment',
  'audit.review.drawer.tag.carLoanRepayment': 'Car Loan Repayment',
  'audit.review.drawer.submittedAt': 'Submitted at',
  'audit.review.drawer.submitted': 'Submitted',
  'audit.review.drawer.section.relatedBankStatement': 'Related Bank Statement',
  'audit.review.drawer.noBankStatement': 'No related bank statement',
  'audit.review.drawer.section.auditDecision': 'Audit Decision',
  'audit.review.drawer.section.auditHistory': 'Audit History',
  'audit.review.drawer.label.auditComment': 'Audit Comment',
  'audit.review.drawer.placeholder.auditComment': 'Please enter your audit comment...',
  'audit.review.drawer.button.reject': 'Reject',
  'audit.review.drawer.button.pass': 'Pass',
  'audit.review.drawer.button.cancel': 'Cancel',
  'audit.review.drawer.button.editBill': 'Edit Document',
  'audit.review.drawer.button.followReview': 'Follow Review',
  'audit.review.drawer.button.unfollowReview': 'Unfollow',
  'audit.review.drawer.button.addComment': 'Information Error',
  'audit.review.drawer.label.quickComments': 'Quick Comments',
  'audit.review.drawer.label.noAttachment': 'No attachment',
  'audit.review.drawer.timeline.submitted': 'Document Submitted',
  'audit.review.drawer.timeline.pending': 'Pending',
  'audit.review.drawer.timeline.completed': 'Completed',
  'audit.review.drawer.timeline.financeAudit': 'Level 1 Finance Audit',
  'audit.review.drawer.timeline.propertyAudit': 'Level 1 Property Audit',
  'audit.review.drawer.label.operator': 'Operator',
  'audit.review.drawer.label.documentCode': 'Document Code',
  'audit.review.drawer.label.accountingAmount': 'Accounting Amount',
  'audit.review.drawer.message.loadDetailFailed': 'Failed to load bill details',
  'audit.review.drawer.message.approveSuccess': 'Approved successfully',
  'audit.review.drawer.message.approveFailed': 'Audit failed',
  'audit.review.drawer.message.markedReviewLater': 'Marked as follow review',
  'audit.review.drawer.message.unmarkedReviewLater': 'Follow review canceled',
  'audit.review.drawer.message.operationFailed': 'Operation failed',
  'audit.review.drawer.message.operationFailedRetry': 'Operation failed, please try again later',
  'audit.review.drawer.message.getBillDetailFailed': 'Failed to get document details',
  'audit.review.drawer.message.unsupportedBillEdit': 'Editing is not supported for this document type',
  'audit.review.drawer.message.rejectReasonRequired': 'Please enter rejection reason',
  'audit.review.drawer.message.rejectSuccess': 'Rejected',
  'audit.review.drawer.message.rejectFailed': 'Audit failed',
  'audit.review.drawer.tab.pending': 'Pending',
  'audit.review.drawer.tab.approved': 'Approved',
  'audit.review.drawer.tab.rejected': 'Rejected',
  'audit.review.drawer.column.houseInfo': 'House Info',
  'audit.review.drawer.column.parkingInfo': 'Parking Info',
  'audit.review.drawer.column.name': 'Name',
  'audit.review.drawer.column.billNo': 'Bill No.',
  'audit.review.drawer.column.status': 'Status',
  'audit.review.drawer.column.amount': 'Amount Due',
  'audit.review.drawer.column.discountAmount': 'Discount Amount',
  'audit.review.drawer.column.lateFee': 'Late Fee',
  'audit.review.drawer.column.finalAmount': 'Final Amount',
  'audit.review.drawer.column.ownerInfo': 'Owner Info',
  'audit.review.drawer.column.action': 'Action',
  'audit.review.drawer.action.approve': 'Approve',
  'audit.review.drawer.action.reject': 'Reject',
  'audit.review.drawer.action.view': 'View',
  'audit.review.drawer.action.batchApprove': 'Batch Approve',
  'audit.review.drawer.action.batchReject': 'Batch Reject',
  'audit.review.drawer.info.period': 'Period:',
  'audit.review.drawer.info.feeType': 'Fee Type:',
  'audit.review.drawer.info.status': 'Status:',
  'audit.review.drawer.info.submitter': 'Submitter',
  'audit.review.drawer.info.submitTime': 'Submit Time',
  'audit.review.drawer.info.submitRemark': 'Submit Remark',
  'audit.review.drawer.statistics.totalAmount': 'Total Amount',
  'audit.review.drawer.statistics.pendingAmount': 'Pending Amount',
  'audit.review.drawer.statistics.approvedAmount': 'Approved Amount',
  'audit.review.drawer.statistics.rejectedAmount': 'Rejected Amount',
  'audit.review.drawer.statistics.totalBills': '{count} bills in total',
  'audit.review.drawer.statistics.pendingBills': '{count} pending',
  'audit.review.drawer.statistics.approvedBills': '{count} approved',
  'audit.review.drawer.statistics.rejectedBills': '{count} rejected',
  'audit.review.drawer.pagination.total': 'Total {total} items',
  'audit.review.drawer.modal.approve.title': 'Audit Confirmation',
  'audit.review.drawer.modal.approve.content': 'Are you sure you want to approve this bill?',
  'audit.review.drawer.modal.approve.billNo': 'Bill No.',
  'audit.review.drawer.modal.approve.amount': 'Amount Due',
  'audit.review.drawer.modal.approve.discountAmount': 'Discount Amount',
  'audit.review.drawer.modal.approve.lateFee': 'Late Fee',
  'audit.review.drawer.modal.approve.finalAmount': 'Final Amount',
  'audit.review.drawer.modal.approve.okText': 'Confirm Approve',
  'audit.review.drawer.modal.approve.success': 'Approved: {billNo}',
  'audit.review.drawer.modal.approve.error': 'Audit failed, please try again',
  'audit.review.drawer.error.amountError': 'Amount input error',
  'audit.review.drawer.modal.reject.title': 'Reject Audit',
  'audit.review.drawer.modal.reject.placeholder': 'Please enter rejection reason (required)',
  'audit.review.drawer.modal.reject.okText': 'Confirm Reject',
  'audit.review.drawer.modal.reject.error.reason': 'Please enter rejection reason',
  'audit.review.drawer.modal.reject.success': 'Rejected: {billNo}',
  'audit.review.drawer.modal.batchApprove.title': 'Batch Audit Confirmation',
  'audit.review.drawer.modal.batchApprove.content': 'Are you sure you want to batch approve the selected bills?',
  'audit.review.drawer.modal.batchApprove.count': '{count} bills will be approved',
  'audit.review.drawer.modal.batchApprove.summary': 'Amount Summary',
  'audit.review.drawer.modal.batchApprove.totalOriginal': 'Total Amount Due',
  'audit.review.drawer.modal.batchApprove.totalDiscount': 'Total Discount',
  'audit.review.drawer.modal.batchApprove.totalLateFee': 'Total Late Fee',
  'audit.review.drawer.modal.batchApprove.totalFinal': 'Total Final Amount',
  'audit.review.drawer.modal.batchApprove.okText': 'Confirm Batch Approve',
  'audit.review.drawer.modal.batchApprove.success': 'Batch approved {count} bills',
  'audit.review.drawer.modal.batchReject.title': 'Batch Reject Audit',
  'audit.review.drawer.modal.batchReject.content': 'Are you sure you want to batch reject the selected bills?',
  'audit.review.drawer.modal.batchReject.count': '{count} bills will be rejected',
  'audit.review.drawer.modal.batchReject.reason': 'Rejection Reason (required)',
  'audit.review.drawer.modal.batchReject.placeholder': 'Please provide detailed rejection reason for the owner to understand...',
  'audit.review.drawer.modal.batchReject.okText': 'Confirm Batch Reject',
  'audit.review.drawer.modal.batchReject.success': 'Batch rejected {count} bills',
  'audit.review.drawer.error.selectBills': 'Please select bills to audit',
  'audit.review.drawer.error.loading': 'Data is loading, please try again later',
  'audit.review.drawer.error.auditId': 'Audit ID does not exist',
  'audit.review.drawer.error.batchFailed': 'Batch audit failed, please try again',
  'audit.review.drawer.error.billIncomplete': 'Bill information is incomplete',
  'audit.review.drawer.error.loadStatistics': 'Failed to load statistics',
  'audit.review.drawer.error.loadData': 'Failed to load full data',
  'audit.review.drawer.error.getBillDetails': 'Failed to get bill details',
  'audit.review.modal.property.title': 'Property Fee Bill Detail',
  'audit.review.modal.parking.title': 'Parking Fee Bill Detail',
  'audit.review.modal.water.title': 'Water Fee Bill Detail',
  'audit.review.modal.electric.title': 'Electric Fee Bill Detail',
  'audit.review.modal.network.title': 'Network Fee Bill Detail',
  'audit.review.modal.other.title': 'Other Fee Bill Detail',
  'audit.review.modal.default.title': 'Bill Detail',
  'audit.review.modal.error.unknownFeeType': 'Unknown fee type',
  'audit.review.modal.error.getDetailFailed': 'Failed to get bill detail',
  'audit.review.modal.section.basic': 'Basic Information',
  'audit.review.modal.section.houseOwner': 'House and Owner Information',
  'audit.review.modal.section.parkingOwner': 'Parking Space and Owner Information',
  'audit.review.modal.section.amount': 'Amount Information',
  'audit.review.modal.section.payment': 'Payment Information',
  'audit.review.modal.section.system': 'System Information',
  'audit.review.modal.section.meter': 'Meter Reading Information',
  'audit.review.modal.section.audit': 'Audit Records',
  'audit.review.modal.label.billNo': 'Bill No.',
  'audit.review.modal.label.period': 'Period',
  'audit.review.modal.label.startTime': 'Start Time',
  'audit.review.modal.label.endTime': 'End Time',
  'audit.review.modal.label.status': 'Payment Status',
  'audit.review.modal.label.houseInfo': 'House Info',
  'audit.review.modal.label.parkingInfo': 'Parking Space Info',
  'audit.review.modal.label.ownerInfo': 'Owner Info',
  'audit.review.modal.label.propertyFee': 'Property Fee',
  'audit.review.modal.label.maintenanceFee': 'Maintenance Fund',
  'audit.review.modal.label.otherFee': 'Other Fee',
  'audit.review.modal.label.lateFee': 'Late Fee',
  'audit.review.modal.label.discountAmount': 'Discount Amount',
  'audit.review.modal.label.finalAmount': 'Total Amount Due',
  'audit.review.modal.label.paymentMethod': 'Payment Method',
  'audit.review.modal.label.paymentReference': 'Payment Reference No.',
  'audit.review.modal.label.dueDate': 'Due Date',
  'audit.review.modal.label.paidDate': 'Payment Date',
  'audit.review.modal.label.createdTime': 'Created Time',
  'audit.review.modal.label.updatedTime': 'Updated Time',
  'audit.review.modal.label.remarks': 'Remarks',
  'audit.review.modal.label.waterUsage': 'Water Usage',
  'audit.review.modal.label.elecUsage': 'Electricity Usage',
  'audit.review.modal.label.lastReading': 'Last Reading',
  'audit.review.modal.label.lastReadingDate': 'Last Reading Date',
  'audit.review.modal.label.currentReading': 'Current Reading',
  'audit.review.modal.label.currentReadingDate': 'Current Reading Date',
  'audit.review.modal.label.unitPrice': 'Unit Price',
  'audit.review.modal.label.amount': 'Base Amount',
  'audit.review.modal.label.billName': 'Bill Name',
  'audit.review.modal.label.feeAmount': 'Fee Amount',
  'audit.review.modal.label.parkingAmount': 'Parking Fee Amount',
  'audit.review.modal.label.networkAmount': 'Network Fee Amount',
  'audit.review.modal.label.finalPayAmount': 'Final Amount Due',
  'audit.review.modal.status.unpaid': 'Unpaid',
  'audit.review.modal.status.paid': 'Paid',
  'audit.review.modal.status.overdue': 'Overdue',
  'audit.review.modal.status.partial': 'Partially Paid',
  'audit.review.modal.status.cancelled': 'Cancelled',
  'audit.review.modal.audit.loading': 'Loading...',
  'audit.review.modal.audit.empty': 'No audit records',
  'audit.review.modal.unit.ton': 'ton',
  'audit.review.modal.unit.degree': 'kWh',
  'audit.review.modal.unit.yuanPerTon': 'yuan/ton',
  'audit.review.modal.unit.yuanPerDegree': 'yuan/kWh',
  'audit.review.feeType.property': 'Property Fee',
  'audit.review.feeType.parking': 'Parking Fee',
  'audit.review.feeType.water': 'Water Fee',
  'audit.review.feeType.electric': 'Electric Fee',
  'audit.review.feeType.network': 'Network Fee',
  'audit.review.feeType.other': 'Other',
  'audit.review.status.pending': 'Pending',
  'audit.review.status.approved': 'Approved',
  'audit.review.status.rejected': 'Rejected',
  'audit.review.status.draft': 'Draft',
  'audit.review.drawer.placeholder.discountAmount': 'Discount Amount',
  'audit.review.drawer.placeholder.lateFee': 'Late Fee',
  'audit.review.drawer.unit.floor': 'F',
  'audit.review.drawer.unit.room': 'Room',
  'audit.review.modal.label.idCard': 'ID Card',
  'audit.review.modal.label.email': 'Email',
  'audit.review.modal.label.ownerIdLabel': 'Owner ID',
  'audit.review.modal.error.getAuditRecordsFailed': 'Failed to get audit records',
  'audit.review.modal.label.lastReadingWithUnit': 'Last Reading',
  'audit.review.modal.label.currentReadingWithUnit': 'Current Reading',
  'audit.review.modal.financialExpense.title': 'Financial Expense Detail',
  'audit.review.modal.budgetRequest.title': 'Budget Request Detail',
  'audit.review.modal.mortgageRepayment.title': 'Mortgage Repayment Detail',
  'audit.review.modal.carRepayment.title': 'Car Loan Repayment Detail',
  'audit.review.modal.financialExpense.label.code': 'Code',
  'audit.review.modal.financialExpense.label.name': 'Expense Name',
  'audit.review.modal.financialExpense.label.type': 'Expense Type',
  'audit.review.modal.financialExpense.label.amount': 'Amount',
  'audit.review.modal.financialExpense.label.applicantBy': 'Applicant ID',
  'audit.review.modal.financialExpense.label.applyReason': 'Application Reason',
  'audit.review.modal.financialExpense.label.auditBy': 'Auditor ID',
  'audit.review.modal.financialExpense.label.auditReason': 'Audit Reason',
  'audit.review.modal.financialExpense.label.relatedFile': 'Related File',
  'audit.review.modal.label.documentName': 'Document Name',
  'audit.review.modal.label.expenseType': 'Expense Type',
  'audit.review.modal.label.amountType': 'Amount Type',
  'audit.review.modal.label.amountType.income': 'Income',
  'audit.review.modal.label.amountType.expense': 'Expense',
  'audit.review.modal.label.applicant': 'Applicant',
  'audit.review.modal.label.payee': 'Payee',
  'audit.review.modal.label.projectName': 'Project Name',
  'audit.review.modal.label.applicationReason': 'Application Reason',
  'audit.review.modal.label.submitRemark': 'Submit Remark',
  'audit.review.modal.label.voucherMaterial': 'Voucher Material',
  'audit.review.modal.label.downloadFile': 'Download File',
  'audit.review.modal.label.statementNo': 'Statement No.',
  'audit.review.modal.label.billingPeriod': 'Billing Period',
  'audit.review.modal.label.bank': 'Bank',
  'audit.review.modal.label.totalIncome': 'Total Income',
  'audit.review.modal.label.totalExpense': 'Total Expense',
  'audit.review.modal.label.auditName': 'Audit Name',
  'audit.review.modal.budgetRequest.label.code': 'Budget Request Code',
  'audit.review.modal.budgetRequest.label.name': 'Budget Request Name',
  'audit.review.modal.budgetRequest.label.billingPeriod': 'Billing Period',
  'audit.review.modal.budgetRequest.label.amount': 'Application Amount',
  'audit.review.modal.budgetRequest.label.applyRemark': 'Application Remark',
  'audit.review.modal.budgetRequest.label.attachment': 'Attachment File',
  'audit.review.modal.common.label.status': 'Status',
  'audit.review.modal.common.label.downloadFile': 'Download File',
  'audit.review.modal.common.label.fileFormat': 'File Format:',
  'audit.review.modal.common.label.fileSize': 'File Size:',
  'audit.review.modal.common.unknown': 'Unknown',
  'audit.review.modal.status.draft': 'Draft',
  'audit.review.modal.status.pending': 'Pending',
  'audit.review.modal.status.approved': 'Approved',
  'audit.review.modal.status.rejected': 'Rejected',
  'audit.reviewed.subTitle': 'Completed audit records, including approved, rejected and other types of fee audit results',
  'audit.reviewed.headerTitle': 'Reviewed List',
  'audit.reviewed.column.approvedAmount': 'Approved Amount',
  'audit.reviewed.column.approverName': 'Approver',
  'audit.reviewed.column.approveTime': 'Approval Time',
  'audit.reviewed.action.view': 'View',
  'audit.reviewed.action.viewTooltip': 'View Details',
  'audit.reviewed.error.loadFeeTypes': 'Failed to load fee type dictionary',
  'audit.reviewed.error.loadApproveStatus': 'Failed to load approval status dictionary',
  'audit.reviewed.error.getList': 'Failed to get audit list',
  'audit.financeReview.subTitle': 'Pending finance audit records in the audit system, including financial expenses, budget requests and other types of finance audits',
  'audit.financeReview.headerTitle': 'Finance Pending Review List',
  'audit.financeReviewed.subTitle': 'Completed finance audit records, including approved, rejected and other types of finance audit results',
  'audit.financeReviewed.headerTitle': 'Finance Reviewed List',
  'audit.financeReviewed.search.page.subTitle': 'View reviewed finance records',
  'audit.financeReviewed.search.table.headerTitle': 'Finance Review Search',
  'audit.financeReviewed.search.action.batchAudit': 'Batch Audit ({count})',
  'audit.financeReviewed.search.message.selectRecordsFirst': 'Please select records to audit first',

  'audit.review.drawer.label.ewtAmount': 'EWT Amount',
  'audit.review.drawer.label.ctoAmount': 'CTO Tax Amount',
  'audit.review.drawer.label.checkNo': 'Check No.',
  'audit.review.drawer.section.configAuditInfo': 'Audit Configuration',
  'audit.review.drawer.label.relatedBankStatement': 'Related Bank Statement',
  'audit.review.drawer.placeholder.selectBankStatement': 'Please select bank statement',
  'audit.review.drawer.button.setDefault': 'Set as Default',
  'audit.review.drawer.label.expenseType': 'Expense Type',
  'audit.review.drawer.placeholder.selectExpenseType': 'Please select expense type',
  'audit.review.drawer.placeholder.inputCheckNo': 'Please enter check number',
  // Approve Confirm Modal
  'audit.review.modal.bankStatement.label': 'Bank Statement',
  'audit.review.modal.bankStatement.placeholder': 'Please select bank statement',
  'audit.review.modal.bankStatement.required': 'Please select bank statement',
  'audit.review.modal.bankStatement.allUseSame': 'All selected bills will use the same bank statement',
  'audit.review.modal.error.loadCurrency': 'Failed to load currency dictionary',
  'audit.review.modal.error.loadBankStatement': 'Failed to load bank statement',

  // Bill Detail Modal - Payment Records
  'audit.review.modal.payment.title': 'Payment History',
  'audit.review.modal.payment.recordTitle': 'Payment Record',
  'audit.review.modal.payment.lateFee': 'Late Fee',
  'audit.review.modal.payment.discountAmount': 'Discount Amount',
  'audit.review.modal.payment.finalAmount': 'Total Amount Due',
  'audit.review.modal.payment.payAmount': 'Actual Payment Amount',
  'audit.review.modal.payment.withholdingAmount': 'Withholding Amount',
  'audit.review.modal.payment.addBalanceAmount': 'Top-up Amount',
  'audit.review.modal.payment.remainAmount': 'Remaining Amount',
  'audit.review.modal.payment.status': 'Payment Status',
  'audit.review.modal.payment.status.paid': 'Paid',
  'audit.review.modal.payment.status.partialPaid': 'Partially Paid',
  'audit.review.modal.payment.payMethod': 'Payment Method',
  'audit.review.modal.payment.outTxnNo': 'Payment Reference No.',
  'audit.review.modal.payment.projectName': 'Project Name',
  'audit.review.modal.payment.bankStatement': 'Related Bank Statement',
  'audit.review.modal.payment.payTime': 'Payment Time',

  // Bill Detail Modal - Other Fee
  'audit.review.modal.other.section.basic': 'Basic Information',
  'audit.review.modal.other.label.billNo': 'Bill No.',
  'audit.review.modal.other.label.period': 'Bill Period',
  'audit.review.modal.other.label.status': 'Payment Status',

  // Bill Detail Modal - Financial Expense
  'audit.review.modal.expense.label.amountType': 'Transaction Type',
  'audit.review.modal.expense.amountType.in': 'Income',
  'audit.review.modal.expense.amountType.out': 'Expense',
};

